/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/replay-5-rec";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "Replay5Rec";
export { I as Replay5Rec };
